import InternalLinkEditing from './internal-link-editing';
import InternalLinkUI from './internal-link-ui';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
export default class InternalLink extends Plugin {
    static get requires() {
        return [InternalLinkEditing, InternalLinkUI];
    }
}
